export const DOCUMENTS = {
  PROMISSORY_NOTE: {
    type: 'file',
    text: 'Pagaré',
    value: 'promissory_note',
    color: 'red darken-4',
  },
  SUBSCRIBER_ID: {
    type: 'file',
    text: 'INE de suscriptor',
    value: 'subscriber_id_document',
    color: 'deep-purple darken-1',
  },
  LEGALREPRESENTATIVE_ID: {
    type: 'file',
    text: 'INE de representante legal',
    value: 'legal_representative_id_document',
  },
  GUARANTOR_ID: {
    type: 'file',
    text: 'INE de aval',
    value: 'guarantor_id_document',
    color: 'teal darken-1',
  },
  SUBSCRIBER_ADDRESS: {
    type: 'file',
    text: 'Comprobante de domicilio de subscriptor',
    value: 'subscriber_proof_of_address',
    color: 'green darken-1',
  },
  GUARANTOR_ADDRESS: {
    type: 'file',
    text: 'Comprobante de domicilio de aval',
    value: 'guarantor_proof_of_address',
    color: 'yellow darken-4',
  },
  TAX_STATUS_CERTIFICATE: {
    type: 'file',
    text: 'Constancia de situación fiscal',
    value: 'tax_status_certificate',
    color: 'brown darken-1',
  },

  ARTICLES_OF_INCORPORATION: {
    type: 'file',
    text: 'Acta constitutiva',
    value: 'articles_of_incorporation',
    color: 'blue-grey darken-1',
  },
  FINANCIAL_STATEMENT: {
    type: 'file',
    text: 'Estados financieros',
    value: 'financial_statement',
    color: 'grey darken-1',
  },
  CREDIT_BUREAU_AUTH: {
    type: 'file',
    text: 'Autorización buró de crédito',
    value: 'credit_bureau_authorization',
    color: 'teal darken-4',
  },
  CREDIT_APPLICATION: {
    type: 'file',
    text: 'Solicitud de crédito',
    value: 'credit_application',
    color: 'cyan darken-4',
  },
  ON_SITE_INSPECTION_REPORT: {
    type: 'file',
    text: 'visita ocular',
    value: 'on_site_inspection_report',
    color: 'indigo darken-4',
  },
};
